'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/scheduler.production.min.js');
} else {
  module.exports = require('./cjs/scheduler.development.js');
}



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/scheduler/index.js
// module id = 245
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16